export enum OutputGroupType {
  HLS = 'HLS',
  MPD = 'MPD',
  FILE = 'File',
}
